export enum SimulationPeriod {
	Daily = "dd/MM/yy",
	Monthly = "MM/yy",
	Weekly = "WW/kk",
	Yearly = "yyyy",
	SmallDay = "dd/MM",
	All = "All",
}
